import React from "react";
import { IconButton, Modal as ModalMUI } from "@mui/material";
import { BoxModal, BtnClose, Container, Title } from "./styled.components";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Circles from "../Loader/Circles";
import { useSelector } from "react-redux";

const Modal = ({
  children,
  title,
  handleChange,
  open = false,
  loader = false,
  size = "40vw",
}: any) => {

  const { bannerModal } = useSelector((state: any) => state.theme)

  return (
    <div>
      {/* <button onClick={handleOpen}>Open modal</button> */}
      <ModalMUI
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <BoxModal size={size}>
          <Title bgImagen={
            bannerModal
              ? `${process.env.PUBLIC_URL}${bannerModal}`
              : "/commons/bg_profile.png"
          } >
            {title}
          </Title>
          <BtnClose>
            {loader ? (
              <Circles />
            ) : (
              <IconButton
                onClick={handleChange()}
                aria-label="delete"
                size="large"
              >
                <HighlightOffIcon fontSize="inherit" />
              </IconButton>
            )}
          </BtnClose>
          <Container>{children}</Container>
        </BoxModal>
      </ModalMUI>
    </div >
  );
};

export default Modal;
